<template>
  <div class="account-sidenav">
    <!-- Profile Card -->
    <div class="account-sidenav__profile">
      <div class="account-sidenav__avatar">
        <img
          :src="organisationDetails.image || 'https://res.cloudinary.com/djalafcj9/image/upload/v1634012152/getequityV2/header-profile-img_kjtkcq.webp'"
          :alt="organisationDetails.name"
          loading="lazy"
        />
      </div>
      <div class="account-sidenav__info">
        <h3 class="account-sidenav__name">{{ truncate(organisationDetails.name, 18) }}</h3>
        <p class="account-sidenav__location">{{ orgCountry || 'Location not set' }}</p>
      </div>
      <button 
        class="account-sidenav__toggle"
        @click="showAccountSidebar = !showAccountSidebar"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Navigation Menu -->
    <nav class="account-sidenav__nav" :class="{ 'account-sidenav__nav--open': showAccountSidebar }">
      <!-- Account Section -->
      <div class="account-sidenav__section">
        <span class="account-sidenav__section-title">Account</span>
        <router-link :to="{ name: 'CompanyInfo' }" class="account-sidenav__link" :class="{ 'account-sidenav__link--active': $route.name === 'CompanyInfo' }">
          <div class="account-sidenav__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 17.5V5.83333C17.5 5.39131 17.3244 4.96738 17.0118 4.65482C16.6993 4.34226 16.2754 4.16667 15.8333 4.16667H4.16667C3.72464 4.16667 3.30072 4.34226 2.98816 4.65482C2.67559 4.96738 2.5 5.39131 2.5 5.83333V17.5M17.5 17.5H2.5M17.5 17.5H19.1667M17.5 17.5V10.8333M2.5 17.5H0.833336M2.5 17.5V10.8333M2.5 10.8333H17.5M6.66667 7.5H8.33333M6.66667 14.1667H8.33333M11.6667 7.5H13.3333M11.6667 14.1667H13.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>Company Information</span>
        </router-link>
        <router-link :to="{ name: 'IdentityVerification' }" class="account-sidenav__link" :class="{ 'account-sidenav__link--active': $route.name === 'IdentityVerification' }">
          <div class="account-sidenav__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16.6667 12.5C16.5557 12.7513 16.5226 13.0302 16.5716 13.3005C16.6207 13.5708 16.7497 13.8203 16.9417 14.0167L16.9917 14.0667C17.1466 14.2215 17.2695 14.4053 17.3534 14.6076C17.4374 14.8099 17.4807 15.0268 17.4807 15.2458C17.4807 15.4649 17.4374 15.6817 17.3534 15.8841C17.2695 16.0864 17.1466 16.2702 16.9917 16.425C16.8369 16.5799 16.6531 16.7028 16.4508 16.7867C16.2484 16.8707 16.0316 16.914 15.8125 16.914C15.5935 16.914 15.3766 16.8707 15.1743 16.7867C14.9719 16.7028 14.7881 16.5799 14.6333 16.425L14.5833 16.375C14.387 16.183 14.1375 16.054 13.8672 16.0049C13.5969 15.9559 13.318 15.989 13.0667 16.1C12.8203 16.2056 12.61 16.3806 12.461 16.6033C12.312 16.826 12.2308 17.0869 12.2275 17.3542V17.5C12.2275 17.942 12.0519 18.3659 11.7394 18.6785C11.4268 18.9911 11.0029 19.1667 10.5609 19.1667C10.1188 19.1667 9.6949 18.9911 9.38234 18.6785C9.06978 18.3659 8.89419 17.942 8.89419 17.5V17.4208C8.88505 17.1451 8.79432 16.8785 8.63363 16.6547C8.47294 16.4309 8.24975 16.2599 7.99252 16.1625C7.74119 16.0515 7.46229 16.0184 7.19199 16.0674C6.92169 16.1165 6.67219 16.2455 6.47585 16.4375L6.42585 16.4875C6.27105 16.6424 6.08727 16.7653 5.88492 16.8492C5.68258 16.9332 5.46574 16.9765 5.24669 16.9765C5.02763 16.9765 4.81079 16.9332 4.60845 16.8492C4.4061 16.7653 4.22232 16.6424 4.06752 16.4875C3.91261 16.3327 3.78972 16.1489 3.70578 15.9466C3.62184 15.7443 3.57853 15.5274 3.57853 15.3084C3.57853 15.0893 3.62184 14.8725 3.70578 14.6701C3.78972 14.4678 3.91261 14.284 4.06752 14.1292L4.11752 14.0792C4.30955 13.8828 4.43854 13.6333 4.48756 13.363C4.53659 13.0927 4.50354 12.8138 4.39252 12.5625C4.28697 12.3162 4.11193 12.1058 3.88923 11.9568C3.66654 11.8078 3.40563 11.7266 3.13835 11.7233H2.99252C2.55049 11.7233 2.12657 11.5477 1.81401 11.2352C1.50145 10.9226 1.32585 10.4987 1.32585 10.0567C1.32585 9.61464 1.50145 9.19071 1.81401 8.87815C2.12657 8.56559 2.55049 8.39 2.99252 8.39H3.07169C3.34743 8.38085 3.61403 8.29013 3.83782 8.12943C4.06161 7.96874 4.2326 7.74555 4.33002 7.48833C4.44104 7.237 4.47409 6.9581 4.42506 6.6878C4.37604 6.4175 4.24705 6.168 4.05502 5.97167L4.00502 5.92167C3.85011 5.76687 3.72722 5.58309 3.64328 5.38074C3.55934 5.1784 3.51603 4.96156 3.51603 4.7425C3.51603 4.52345 3.55934 4.30661 3.64328 4.10426C3.72722 3.90192 3.85011 3.71814 4.00502 3.56333C4.15982 3.40842 4.3436 3.28554 4.54595 3.2016C4.74829 3.11765 4.96513 3.07434 5.18419 3.07434C5.40325 3.07434 5.62008 3.11765 5.82243 3.2016C6.02477 3.28554 6.20855 3.40842 6.36335 3.56333L6.41335 3.61333C6.60969 3.80537 6.85919 3.93435 7.12949 3.98338C7.39979 4.0324 7.67869 3.99935 7.93002 3.88833H8.00002C8.24637 3.78278 8.45675 3.60775 8.60577 3.38505C8.75479 3.16235 8.83595 2.90145 8.83919 2.63417V2.5C8.83919 2.05797 9.01478 1.63405 9.32734 1.32149C9.6399 1.00893 10.0638 0.833332 10.5059 0.833332C10.9479 0.833332 11.3718 1.00893 11.6844 1.32149C11.9969 1.63405 12.1725 2.05797 12.1725 2.5V2.57917C12.1758 2.84645 12.2569 3.10735 12.406 3.33005C12.555 3.55275 12.7654 3.72778 13.0117 3.83333C13.263 3.94435 13.5419 3.9774 13.8122 3.92838C14.0825 3.87935 14.332 3.75037 14.5284 3.55833L14.5784 3.50833C14.7332 3.35342 14.9169 3.23054 15.1193 3.1466C15.3216 3.06265 15.5385 3.01934 15.7575 3.01934C15.9766 3.01934 16.1934 3.06265 16.3958 3.1466C16.5981 3.23054 16.7819 3.35342 16.9367 3.50833C17.0916 3.66314 17.2145 3.84692 17.2984 4.04926C17.3824 4.25161 17.4257 4.46845 17.4257 4.6875C17.4257 4.90656 17.3824 5.1234 17.2984 5.32574C17.2145 5.52809 17.0916 5.71187 16.9367 5.86667L16.8867 5.91667C16.6946 6.113 16.5657 6.3625 16.5166 6.6328C16.4676 6.9031 16.5006 7.182 16.6117 7.43333V7.5C16.7172 7.74635 16.8922 7.95673 17.1149 8.10575C17.3376 8.25478 17.5985 8.33593 17.8658 8.33917H18.0117C18.4537 8.33917 18.8776 8.51476 19.1902 8.82732C19.5028 9.13988 19.6784 9.5638 19.6784 10.0058C19.6784 10.4479 19.5028 10.8718 19.1902 11.1843C18.8776 11.4969 18.4537 11.6725 18.0117 11.6725H17.9325C17.6652 11.6758 17.4043 11.7569 17.1816 11.906C16.9589 12.055 16.7839 12.2654 16.6784 12.5117L16.6667 12.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>Identity Verification</span>
        </router-link>
        <router-link :to="{ name: 'ProfileSummary' }" class="account-sidenav__link" :class="{ 'account-sidenav__link--active': $route.name === 'ProfileSummary' }">
          <div class="account-sidenav__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 10C12.3012 10 14.1667 8.13452 14.1667 5.83333C14.1667 3.53215 12.3012 1.66667 10 1.66667C7.69882 1.66667 5.83334 3.53215 5.83334 5.83333C5.83334 8.13452 7.69882 10 10 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17.5 18.3333C17.5 15.1917 14.1417 12.5 10 12.5C5.85834 12.5 2.5 15.1917 2.5 18.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>Profile Summary</span>
        </router-link>
        <router-link :to="{ name: 'ManageFeatures' }" class="account-sidenav__link" :class="{ 'account-sidenav__link--active': $route.name === 'ManageFeatures' }">
          <div class="account-sidenav__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V7.5C2.5 8.42047 3.24619 9.16667 4.16667 9.16667H7.5C8.42047 9.16667 9.16667 8.42047 9.16667 7.5V4.16667C9.16667 3.24619 8.42047 2.5 7.5 2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.8333 2.5H12.5C11.5795 2.5 10.8333 3.24619 10.8333 4.16667V7.5C10.8333 8.42047 11.5795 9.16667 12.5 9.16667H15.8333C16.7538 9.16667 17.5 8.42047 17.5 7.5V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.5 10.8333H4.16667C3.24619 10.8333 2.5 11.5795 2.5 12.5V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H7.5C8.42047 17.5 9.16667 16.7538 9.16667 15.8333V12.5C9.16667 11.5795 8.42047 10.8333 7.5 10.8333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.8333 10.8333H12.5C11.5795 10.8333 10.8333 11.5795 10.8333 12.5V15.8333C10.8333 16.7538 11.5795 17.5 12.5 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V12.5C17.5 11.5795 16.7538 10.8333 15.8333 10.8333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>Manage Features</span>
        </router-link>
        <router-link :to="{ name: 'ManageBank' }" class="account-sidenav__link" :class="{ 'account-sidenav__link--active': $route.name === 'ManageBank' }">
          <div class="account-sidenav__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.5 7.5L10 2.5L17.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4.16666 9.16667V15.8333H15.8333V9.16667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.66666 17.5H18.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.5 12.5H12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>Manage Bank</span>
        </router-link>
      </div>

      <!-- Organization Section -->
      <div class="account-sidenav__section">
        <span class="account-sidenav__section-title">Organization</span>
        <router-link :to="{ name: 'FounderInfo' }" class="account-sidenav__link" :class="{ 'account-sidenav__link--active': $route.name === 'FounderInfo' }">
          <div class="account-sidenav__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1903 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16667C3.28261 12.5 2.43477 12.8512 1.80965 13.4763C1.18452 14.1014 0.833336 14.9493 0.833336 15.8333V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.5 9.16667C9.34095 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34095 2.5 7.5 2.5C5.65905 2.5 4.16667 3.99238 4.16667 5.83333C4.16667 7.67428 5.65905 9.16667 7.5 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19.1667 17.5V15.8333C19.1661 15.0948 18.9203 14.3773 18.4678 13.7936C18.0153 13.2099 17.3818 12.793 16.6667 12.6083" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.3333 2.60834C14.0503 2.79192 14.6858 3.20892 15.1396 3.79359C15.5935 4.37827 15.8398 5.09736 15.8398 5.8375C15.8398 6.57764 15.5935 7.29673 15.1396 7.88141C14.6858 8.46609 14.0503 8.88309 13.3333 9.06667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>Founders' Information</span>
        </router-link>
        <router-link :to="{ name: 'CompanyUpdate' }" class="account-sidenav__link" :class="{ 'account-sidenav__link--active': $route.name === 'CompanyUpdate' }">
          <div class="account-sidenav__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10 5V10L13.3333 11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>Company Updates</span>
        </router-link>
      </div>

      <!-- Security Section -->
      <div class="account-sidenav__section">
        <span class="account-sidenav__section-title">Security & Privacy</span>
        <router-link :to="{ name: 'Security' }" class="account-sidenav__link" :class="{ 'account-sidenav__link--active': $route.name === 'Security' || $route.name === 'ChangePassword' }">
          <div class="account-sidenav__icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.3333C10 18.3333 16.6667 15 16.6667 10V4.16667L10 1.66667L3.33334 4.16667V10C3.33334 15 10 18.3333 10 18.3333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>Login & Security</span>
        </router-link>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { truncate } from "@/utils/helpers.js";
import countryRegionState from "@/utils/js/countryRegionData";

export default {
  name: "AccountSideNav",
  
  data() {
    return {
      showAccountSidebar: false,
      countryRegionState,
    };
  },

  computed: {
    ...mapGetters("organisationModule", ["organisationDetails"]),
    orgCountry() {
      let country = null;
      let countryInfo = this.countryRegionState.filter(
        (country) =>
          country.countryShortCode === this.organisationDetails.country ||
          country.countryName === this.organisationDetails.country
      );
      country = countryInfo.length > 0 && countryInfo[0].countryName;
      return country;
    },
  },
  
  methods: {
    truncate,
  },
};
</script>

<style lang="scss" scoped>
.account-sidenav {
  width: 100%;
  background: white;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  overflow: hidden;

  @media (min-width: 768px) {
    width: 280px;
    flex-shrink: 0;
    position: sticky;
    top: 24px;
    align-self: flex-start;
  }

  &__profile {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 20px;
    border-bottom: 1px solid #E2E8F0;
  }

  &__avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    border: 2px solid #E2E8F0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__name {
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 2px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__location {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #64748B;
    margin: 0;
  }

  &__toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: #F8FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    color: #64748B;
    cursor: pointer;
    transition: all 0.15s ease;

    @media (min-width: 768px) {
      display: none;
    }

    &:hover {
      background: white;
      border-color: #4D84FF;
      color: #4D84FF;
    }
  }

  &__nav {
    display: none;
    padding: 12px 0;

    @media (min-width: 768px) {
      display: block;
    }

    &--open {
      display: block;
    }
  }

  &__section {
    padding: 8px 12px;

    &:not(:last-child) {
      border-bottom: 1px solid #F1F5F9;
      margin-bottom: 8px;
      padding-bottom: 16px;
    }
  }

  &__section-title {
    display: block;
    font-family: 'DM Sans', sans-serif;
    font-size: 11px;
    font-weight: 500;
    color: #94A3B8;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 0 8px;
    margin-bottom: 8px;
  }

  &__link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #475569;
    text-decoration: none;
    transition: all 0.15s ease;

    &:hover {
      background: #F8FAFC;
      color: #0F172A;
    }

    &--active {
      background: #EEF4FF;
      color: #4D84FF;

      .account-sidenav__icon {
        color: #4D84FF;
      }
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: #64748B;
    flex-shrink: 0;
  }
}
</style>
